if (!customElements.get('fp-casella-digitale')) {
  customElements.define(
    'fp-casella-digitale',
    class FpCasellaDigitale extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.casella = this.querySelector('input[type="checkbox"]');
        this.campoData = this.querySelector('[data-fp-data]');
        this.casella.addEventListener('change', this.onChange);
        this.aggiornaBottone();
      }

      disconnectedCallback() {
        this.casella.removeEventListener('change', this.onChange);
        const bottone = this.bottone();
        if (!bottone || !bottone.hasAttribute('data-fp-bloccato')) return;
        if (document.querySelector(`fp-casella-digitale[data-bottone="${this.dataset.bottone}"]`)) return;

        bottone.removeAttribute('data-fp-bloccato');
        bottone.disabled = false;
      }

      bottone() {
        return document.getElementById(this.dataset.bottone);
      }

      aggiornaBottone() {
        const bottone = this.bottone();
        if (!bottone) return;

        if (this.casella.checked) {
          if (bottone.hasAttribute('data-fp-bloccato')) {
            bottone.removeAttribute('data-fp-bloccato');
            bottone.disabled = false;
          }
        } else if (!bottone.disabled) {
          bottone.setAttribute('data-fp-bloccato', '');
          bottone.disabled = true;
        }
      }

      onChange() {
        if (!this.casella.checked) {
          this.campoData.value = '';
          this.aggiornaBottone();
          this.salva('', '', '');
          return;
        }

        this.carrelloInvariato().then((invariato) => {
          if (!this.casella.checked) return;

          if (!invariato) {
            this.casella.checked = false;
            this.ricarica();
            return;
          }

          const adesso = new Date();
          this.campoData.value = `${adesso.toLocaleString('it-IT', {
            timeZone: 'Europe/Rome',
          })} ora italiana (${adesso.toISOString()})`;
          this.aggiornaBottone();
          this.salva(this.casella.value, this.campoData.value, this.dataset.prodotti);
        });
      }

      carrelloInvariato() {
        return fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((carrello) => carrello.items.map((riga) => riga.key).join(',') === this.dataset.righe)
          .catch(() => true);
      }

      ricarica() {
        const cassetto = this.closest('cart-drawer') ? document.querySelector('cart-drawer-items') : null;
        if (cassetto && typeof cassetto.onCartUpdate === 'function') {
          cassetto.onCartUpdate();
          return;
        }
        window.location.reload();
      }

      salva(testo, data, prodotti) {
        const attributi = {};
        attributi[this.dataset.chiave] = testo;
        attributi[this.dataset.chiaveData] = data;
        attributi[this.dataset.chiaveProdotti] = prodotti;

        return fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body: JSON.stringify({ attributes: attributi }) },
        }).catch(() => {});
      }
    }
  );

  const fpControllaPaginaCarrello = () => {
    const segno = document.querySelector('#main-cart-footer [data-fp-righe]');
    if (!segno) return;

    fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((carrello) => {
        if (carrello.items.map((riga) => riga.key).join(',') !== segno.dataset.fpRighe) window.location.reload();
      })
      .catch(() => {});
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') fpControllaPaginaCarrello();
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) fpControllaPaginaCarrello();
  });
}
